import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import DecoratedBox from "../../../../../app/components/DecoratedBox";
import { translate as t } from "../../../../../infrastructure/translate/localization";

export const ConsumptionCategory = ({
  icon,
  title,
  flex,
  socialBenefit,
  flexNotExempt,
  accumulatedRecovered,
  socialBenefitRecovered,
  item,
  container,
  ...rest
}) => {
  return (
    <DecoratedBox
      item={item || true}
      container={container || true}
      {...rest}
      alignItems="flex-start"
      alignContent="flex-start"
    >
      <Typography variant="h5" paragraph component="div">
        <Grid alignItems="center" spacing={1} item container>
          <Grid item>
            <FontAwesomeIcon icon={icon} className="icon icon-primary" />
          </Grid>
          <Grid item>{title}</Grid>
        </Grid>
      </Typography>

      <Grid component="ul" container alignItems="flex-start">
        {flex && (
          <Grid component="li" container justify="space-between" item>
            <Grid className="capitalize">{t("common-messages.flex")}</Grid>
            <Grid>{flex}</Grid>
          </Grid>
        )}

        {socialBenefit && (
          <Grid component="li" container justify="space-between" item>
            <Grid className="capitalize">
              {t("common-messages.social-benefit")}
            </Grid>
            <Grid>{socialBenefit}</Grid>
          </Grid>
        )}
        {flexNotExempt && (
          <Grid component="li" container justify="space-between" item>
            <Grid className="capitalize">
              {t("common-messages.not-exempt")}
            </Grid>
            <Grid>{flexNotExempt}</Grid>
          </Grid>
        )}
        {accumulatedRecovered && (
          <Grid component="li" container justify="space-between" item>
            <Grid className="capitalize">
              {t("common-messages.accumulated-recovered")}
            </Grid>
            <Grid>{accumulatedRecovered}</Grid>
          </Grid>
        )}
        {socialBenefitRecovered && (
          <Grid component="li" container justify="space-between" item>
            <Grid className="capitalize">
              {t("common-messages.social-benefit-recovered")}
            </Grid>
            <Grid>{socialBenefitRecovered}</Grid>
          </Grid>
        )}
      </Grid>
    </DecoratedBox>
  );
};

ConsumptionCategory.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  flex: PropTypes.string,
  socialBenefit: PropTypes.string,
  flexNotExempt: PropTypes.string,
  accumulatedRecovered: PropTypes.string,
  socialBenefitRecovered: PropTypes.string,
  item: PropTypes.bool,
  container: PropTypes.bool,
};
ConsumptionCategory.defaultProps = {
  flex: null,
  socialBenefit: null,
  flexNotExempt: null,
  accumulatedRecovered: null,
  socialBenefitRecovered: null,
  item: true,
  container: true,
};

export default ConsumptionCategory;
